import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/Other/FAQSection.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/Other/Footer/Footer.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/Other/HotelsGrid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Other/Navbar/Navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Other/OtherServices.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Other/Search/AdvancedSearch.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/Other/SpecialBlog/SpecialOffers.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/Other/WhyIranija.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/SpecialOffersSection.tsx");
